/* eslint-disable react/display-name */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { KnovioLabel } from '../api/connections.dao';

const connectionsDetailsLabels = () => {
    return {
        EMBED_CODE_ID: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.embedCodeId'
            description='Embed Code ID label'
            defaultMessage='Embed Code ID'
        />,
        KNOVIO_LINK: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.knovioLink'
            description={`${KnovioLabel.Project} Link label`}
            defaultMessage={`${KnovioLabel.Project} Link`}
        />,
        ONECLICK_START_LIVESTREAM_LINK: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.oneclickStartLivestreamLink'
            description='One-Click Start Livestream Link label'
            defaultMessage='One-Click Start Livestream Link'
        />,
        KNOVIO_PODIUM_LINK: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.knovioPodiumLink'
            description='Podium Link label'
            defaultMessage='Podium 1.0 Link'
        />,
        KNOVIO_PODIUM_ACCESS_CODE: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.knovioPodiumAccessCode'
            description='Podium Access Code label'
            defaultMessage='Podium 1.0 Access Code'
        />,
        KNOVIO_PODIUM_EMBED_CODE: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.knovioPodiumEmbedCode'
            description='Podium Embed Code label'
            defaultMessage='One-Click Podium 1.0 Link'
        />,
        LINK: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.link'
            description='Link label'
            defaultMessage='Link'
        />,
        NAME: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.name'
            description='Name label'
            defaultMessage='Name'
        />,
        CONNECTION_NAME: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.connectionName'
            description='Connection Name label'
            defaultMessage='Connection Name'
        />,
        CONNECTION_ID: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.connectionId'
            description='Connection ID label'
            defaultMessage='Connection ID'
        />,
        MEETING_ID: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.meetingiD'
            description='Meeting ID label'
            defaultMessage='Meeting ID'
        />,
        MEETING_PASSCODE: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.meetingPasscode'
            description='Meeting Passcode label'
            defaultMessage='Meeting Passcode'
        />,
        ACCOUNT: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.account'
            description='Account label'
            defaultMessage='Account'
        />,
        HOST_KEY: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.hostkey'
            description='Host Key label'
            defaultMessage='Host Key'
        />,
        SHOWCASE_NAME: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.showcaseName'
            description='Showcase Name Label'
            defaultMessage='Showcase Name'
        />,
        PAGE_PATH: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.pagePath'
            description='Page Path Label'
            defaultMessage='Page Path'
        />,
        SIP: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.sip'
            description='SIP Label'
            defaultMessage='SIP'
        />,
        VERACAST_EVENT_ID: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.eventID'
            description='Event ID Label'
            defaultMessage='Event ID'
        />,
        VERACAST_EVENT_URL: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.eventURL'
            description='Event URL Label'
            defaultMessage='Event URL'
        />,
        CLIENT_APP_LINK: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.clientAppLink'
            description='Client App Link Label'
            defaultMessage='Client App Link'
        />,
        PROVIDER: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.Provider'
            description='Provider Label'
            defaultMessage='Provider'
        />,
        AUDIO_BRIDGE_NAME: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.AudioBridgeName'
            description='Audio Bridge Name Label'
            defaultMessage='Audio Bridge Name'
        />,
        AUDIO_BRIDGE_ID: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.AudioBridgeID'
            description='Audio Bridge ID Label'
            defaultMessage='Audio Bridge ID'
        />,
        PARTICIPANT_TELEPHONE_NUMBERS: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.ParticipantTelephoneNumbers'
            description='Participant Telephone Numbers Label'
            defaultMessage='Participant Telephone Numbers'
        />,
        CONFERENCE_ID: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.ConferenceID'
            description='Conference ID Label'
            defaultMessage='Conference ID'
        />,
        PARTICIPANT_ID: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.ParticipantID'
            description='Participant ID Label'
            defaultMessage='Participant ID'
        />,
        PASSCODE: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.Passcode'
            description='Passcode Label'
            defaultMessage='Passcode'
        />,
        OPERATOR_TELEPHONE_NUMBER: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.OperatorTelephoneNumber'
            description='Operator Telephone Number Label'
            defaultMessage='Operator Telephone Number'
        />,
        OPERATOR_PIN: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.OperatorPIN'
            description='Operator PIN Label'
            defaultMessage='Operator PIN'
        />,
        REGISTRATION_LINK: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.RegistrationLink'
            description='Registration Link Label'
            defaultMessage='Registration Link'
        />,
        TELEPHONE_NUMBER_SET: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.TelephoneNumberSet'
            description='Telephone Number Set Label'
            defaultMessage='Telephone Number Set'
        />,
        ATTENDEE_EMAIL: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.attendeeEmail'
            description='Attendee Email'
            defaultMessage='Attendee Email'
        />,
        WEBINAR_ID: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.webinarId'
            description='Webinar ID'
            defaultMessage='Webinar ID'
        />,
        CONNECTION_LINK: () => <FormattedMessage
            id='oe.connectionsDetailsLabels.connectionLink'
            description='Connection Link'
            defaultMessage='Connection Link'
        />,
    };
};

const childConnectionDetailsLabels = () => {
    return {
        ATTENDEE_EMAIL: () => <FormattedMessage
            id='oe.uniqueJoinMethodDetailsLabels.attendeeEmail'
            description='Attendee Email'
            defaultMessage='Attendee Email'
        />,
        ATTENDEE_ID: () => <FormattedMessage
            id='oe.uniqueJoinMethodDetailsLabels.attendeeId'
            description='Attendee ID'
            defaultMessage='Attendee ID'
        />,
        CONNECTION_LINK: () => <FormattedMessage
            id='oe.uniqueJoinMethodDetailsLabels.connectionLink'
            description='Connection Link'
            defaultMessage='Connection Link'
        />,
        CONNECTION_ID: () => <FormattedMessage
            id='oe.uniqueJoinMethodDetailsLabels.connectionId'
            description='Connection Id'
            defaultMessage='Connection Id'
        />,
        PARTICIPANT_ID: () => <FormattedMessage
            id='oe.uniqueJoinMethodDetailsLabels.participantId'
            description='Participant ID'
            defaultMessage='Participant ID'
        />,
        CONFERENCE_ID: () => <FormattedMessage
            id='oe.uniqueJoinMethodDetailsLabels.conferenceId'
            description='Conference ID'
            defaultMessage='Conference ID'
        />,
        USER_ID: () => <FormattedMessage
            id='oe.uniqueJoinMethodDetailsLabels.userId'
            description='User ID'
            defaultMessage='User ID'
        />,
        WEBINAR_ID: () => <FormattedMessage
            id='oe.panelistLinkDetailsLabels.webinarId'
            description='Webinar ID'
            defaultMessage='Webinar ID'
        />,
    };
};

const passportReplayInfoMessage = <FormattedMessage
    id='oe.connections.passportReplayEnabled.infoMessage'
    description='Input label'
    defaultMessage={`
        Once the meeting has ended, Passport Replay connections will be automatically made available to every attendee,
        regardless of whether the attendee had another connection for the live meeting.
    `}
/>;

const knovioPublishInfoMessage = <FormattedMessage
    id='oe.connections.knovioConnectionPublish.infoMessage'
    description='Input label'
    defaultMessage={`
        If the Connection is Unpublished, attendees will not be able to watch the ${KnovioLabel.OEStream}.
        The Placeholder Text will be displayed to the attendee in place of the ${KnovioLabel.OEStream} thumbnail.
        Use this option if you want to control when your ${KnovioLabel.OEStream} goes live.
    `}
/>;

export const webinarAutoRegistrationInfoMessage = <FormattedMessage
    id='oe.zoomWebinar.passportAutoRegistration.infoMessage'
    description='Input label'
    defaultMessage={`
        Choose Passport Auto Registration if you want all attendees who register on OE Passport to be registered for this webinar automatically.
        All attendees will join the webinar through OE Passport. All Email communication will come from OE Passport, not Zoom.
    `}
/>;

export const webinarSyncMeetingAttendeeInfoMessage = <FormattedMessage
    id='oe.zoomWebinar.syncMeetingAttendeesWithZoom.infoMessage'
    description='Input label'
    defaultMessage={`
        Choose this option if you want Meeting Attendees to be registered for the webinar.
        The system will create Unique Joining Link connections for every attendee who is added to this meeting,
        unless they have another connection assigned.
        This includes attendees added directly to OE Central, and attendees who self-register for this meeting via OE Passport.
        All attendees will join the webinar via OE Passport. All email communication will be from OE Passport rather than Zoom.
    `}
/>;

export const webinarSyncMeetingAttendeeInfoMessageV2 = <FormattedMessage
    id='oe.zoomWebinar.syncMeetingAttendeesWithZoom.V2.infoMessage'
    description='Input label'
    defaultMessage={`
        Choose this option if you want Meeting Attendees to be registered for the webinar.
        The system will create Unique Joining Link connections for every meeting attendee who is assigned or inherits this connection.
        This includes attendees added directly to OE Central, and attendees who self-register for this meeting via OE Passport.
        All attendees will join the webinar via OE Passport. All email communication will be from OE Passport rather than Zoom.
    `}
/>;

export const zoomMeetingAutoRegistrationInfoMessage = <FormattedMessage
    id='oe.zoomMeeting.passportAutoRegistration.infoMessage'
    description='Input label'
    defaultMessage={`
        Choose Passport Auto Registration if you want all attendees who register on OE Passport to be registered for this meeting automatically.
        All attendees will join the meeting through OE Passport. All Email communication will come from OE Passport, not Zoom.
    `}
/>;

export const zoomMeetingAutoSyncInfoMessage = <FormattedMessage
    id='oe.zoomMeeting.syncMeetingAttendeesWithZoom.infoMessage'
    description='Input label'
    defaultMessage={`
        Choose this option if you want Meeting Attendees to be registered for the Zoom meeting.
        The system will create Unique Zoom Registrant connections for every attendee who is added to this meeting,
        unless they have another connection assigned.
        This includes attendees added directly to OE Central, and attendees who self-register for this meeting via OE Passport.
        All attendees will join the webinar via OE Passport.  All email communication will be from OE Passport rather than Zoom.
    `}
/>;

export const zoomMeetingAutoSyncInfoMessageV2 = <FormattedMessage
    id='oe.zoomMeeting.syncMeetingAttendeesWithZoom.V2.infoMessage'
    description='Input label'
    defaultMessage={`
        Choose this option if you want Meeting Attendees to be registered for the Zoom meeting.
        The system will create Unique Zoom Registrant connections for every meeting attendee who is assigned or inherits this connection.
        This includes attendees added directly to OE Central, and attendees who self-register for this meeting via OE Passport.
        All attendees will join the webinar via OE Passport. All email communication will be from OE Passport rather than Zoom.
    `}
/>;

export const syncAudioBridgeAttendeeInfoMessage = <FormattedMessage
    id='oe.audioBridge.syncAudioBridgeAttendee.infoMessage'
    description='Input label'
    defaultMessage={`
        Choose this option if you want only Meeting Attendees, not all Event Attendees, to be registered for the audio call.
        The system will create and assign Unique Dial In Code connections for each Meeting Attendee,
        unless they already have another connection for the meeting assigned.
        This includes attendees added directly to OE Central, and attendees who self-register for this meeting via OE Passport.
    `}
/>;

const meetingConnectionsAutoRegInfoMessage = <FormattedMessage
    id='oe.meetingConnections.autoReg.infoMessage'
    description='Input label'
    defaultMessage={`
        If Auto Registration is enabled, every attendee who registers for the Event on OE Passport will automatically 
        be added as a Registrant attendee of this meeting.
    `}
/>;

const meetingConnectionsAutoSubscriptionInfoMessage = <FormattedMessage
    id='oe.meetingConnections.autoSubscription.infoMessage'
    description='Input label'
    defaultMessage={`
        When enabled all attendees who register via passport will be auto subscribed to this meeting. 
        They will receive a calendar invite and any future updates.
    `}
/>;

const DETAILS_PLACEHOLDER_TEXT_DEFAULT_VALUE = 'This replay is not yet available.';

const alertMessage = <FormattedMessage
    id='oe.connections.alerts.areYouSure'
    description='Alert message'
    defaultMessage='Are you sure you want to'
/>;

const alertAudioBridgeConnectionMessage = <FormattedMessage
    id='oe.connections.alerts.deleteThisAudioBridgeConnection'
    description='Alert message second part'
    defaultMessage=' delete this Audio Bridge Connection'
/>;

const audioBrdigeWarningMessage = <FormattedMessage
    id='oe.connections.alerts.deleteBothTheAudioBridgeAndTheConnectionOrDeleteOnlyTheConnectionWillBeDeletedAndUnassigned'
    description='Warning message'
    defaultMessage='You can choose to permanently delete both the Audio Bridge and the Connection, or to delete only the Connection and unassign it from all attendees.'
/>;

const cancelCreateAudioBridgeMessage = <FormattedMessage
    id='oe.meeting.cancelCreatingAudioBridge'
    defaultMessage='cancel creating this Audio Bridge connection'
    description='Label text'
/>;

const cancelConnectionText = <FormattedMessage
    id='oe.common.alerts.yesCancelOnlyConnection'
    description='Button label'
    defaultMessage='Yes, Cancel only Connection'
/>;

const deleteConnectionText = <FormattedMessage
    id='oe.common.alerts.yesDeleteBoth'
    description='Button label'
    defaultMessage='Yes, Delete Both'
/>;

const goBackText = <FormattedMessage
    id='oe.common.alerts.goBack'
    description='Button label'
    defaultMessage='Go Back'
/>;

export {
    connectionsDetailsLabels,
    childConnectionDetailsLabels,
    passportReplayInfoMessage,
    knovioPublishInfoMessage,
    alertMessage,
    alertAudioBridgeConnectionMessage,
    audioBrdigeWarningMessage,
    cancelCreateAudioBridgeMessage,
    cancelConnectionText,
    deleteConnectionText,
    goBackText,
    DETAILS_PLACEHOLDER_TEXT_DEFAULT_VALUE,
    meetingConnectionsAutoRegInfoMessage,
    meetingConnectionsAutoSubscriptionInfoMessage
};
